










































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { SwiperSlide } from 'vue-awesome-swiper'
import store from 'src/assets/store'
import ItemDataLive from 'src/assets/ItemDataLive'
import { AttendeeItemData, AttendeeResponseResult, Slide, SlideStatistics } from 'src/assets/AttendeeItemData'
import SlidesViewer from 'components/presenter/item/topic/viewer/SlidesViewer.vue'
import SlidesViewerSlide from 'components/presenter/item/topic/viewer/SlidesViewerSlide.vue'
import SlidePreviewTail from 'components/presenter/item/topic/viewer/PreviewTail.vue'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import ButtonClose from 'components/presenter/item/session/manager/ButtonClose.vue'
import SignupCodeButton from 'components/presenter/item/SignupCodeButton.vue'
import SessionController from 'components/presenter/item/session/manager/Controller.vue'
import SlideshowSetup from 'components/presenter/item/session/manager/SlideshowSetup.vue'
import SlideSettings from 'components/presenter/item/session/manager/SlideSettings.vue'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import SlidesEditorForm from 'components/presenter/item/topic/editor/SlidesEditorForm.vue'
import MenuButtonAdd from 'components/presenter/item/topic/MenuButtonAdd.vue'
import api from 'src/assets/api/gql'
import SessionUpdate from 'src/graphql/session/SessionUpdate.gql'
import { ItemTypeTopic, Session, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
    SwiperSlide,
    SlidesViewer,
    SlidesViewerSlide,
    SlidePreviewTail,
    PersonAvatar,
    ButtonClose,
    SignupCodeButton,
    SessionController,
    SlideshowSetup,
    SlideSettings,
    DialogFullscreen,
    SlidesEditorForm,
    MenuButtonAdd
  }
})
export default class PagePresenterSession extends Vue {
  ItemTypeTopic = ItemTypeTopic
  attendeeResponseResult: AttendeeResponseResult | null = null

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendees!: { [key: string]: SessionAttendee }

  @Prop()
  readonly slides!: Json[]

  @Prop()
  readonly gridSlides!: Json[]

  @Prop()
  readonly currSlideIndex!: number

  @Prop()
  readonly currSlide!: Json

  @Prop()
  readonly rightDrawerShowing!: boolean

  @Ref()
  readonly viewer!: SlidesViewer

  @Ref()
  readonly editSlideDialog!: DialogFullscreen

  get currSlideStatistics () {
    if (this.currSlide) {
      return new SlideStatistics(this.currSlide as Slide, Object.values(this.attendees).map(a => a.data?.responseResult || {} as AttendeeResponseResult))
    }
  }

  get startSlide () {
    return {
      id: 'start',
      type: 'Start',
      topic: this.session.topic,
      session: this.session
    }
  }

  get showSlides () {
    return this.session.topic?.typeTopic === ItemTypeTopic.Keynote ? [this.startSlide, ...this.gridSlides] : []
  }

  get isSessionStarted () {
    return this.session.startedAt && (new Date(this.session.startedAt) < store.now())
  }

  get isSessionOver () {
    return this.session.stoppedAt && (new Date(this.session.stoppedAt) < store.now())
  }

  // get attendeeCount () {
  //   return Object.keys(this.attendees).length
  // }

  @Watch('session.topic.data', { immediate: true, deep: true })
  createResult () {
    if (this.session.topic) {
      const attendee = { data: {} } as SessionAttendee
      const attendeeItemData = new AttendeeItemData(this.session.topic.typeTopic as ItemTypeTopic, this.session.topic.data as ItemDataLive, attendee)
      this.attendeeResponseResult = new AttendeeResponseResult(attendeeItemData)
    }
  }

  signupCodeRegenerate (signupCode: string) {
    this.$emit('save', { signupCode })
  }

  change (id: string) {
    this.$nextTick(() => {
      if (this.session?.topic?.typeTopic === ItemTypeTopic.Keynote) {
        this.$emit('save', {
          data: { showSlideId: id || null }
        })
      }
    })
  }

  async saveSlideMeta (data: Json) {
    const meta: { [key: string]: any } = {}
    meta[ data.slide.id + ':feedback' ] = data.meta.feedback
    this.$emit('save', { data: meta })
  }
}
